<template>
  <div class="options">
    <div
      v-for="(item, key) in options"
      :key="key"
      @click="change(item, key)"
      :class="{ active: isActive(key) }"
      class="op-btn"
    >
      <el-row>
        <el-col :span="4" class="letter">{{letter[key]}}</el-col>
        <el-col :span="20">{{item}}</el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { Row, Col } from 'element-ui';
import utils from '@/services/utils';

export default {
  components: {
    ElRow: Row,
    ElCol: Col,
  },
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    results: {
      type: Array,
      default: () => [],
    },
    isDone: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      letter: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
    };
  },
  methods: {
    change(answer, key) {
      if (!this.isDone) {
        this.$emit('change', answer, key);
      }
    },
    isActive(key) {
      const index = utils.Array.findIndex(this.results, { selectedIndex: key }, 'selectedIndex');
      return index > -1;
    },
    randomOption(arr) {
      const l = arr.length;
      const currentIndex = Math.floor(Math.random() * l);
      const goToIndex = Math.floor(Math.random() * l);
      const currentOption = arr[currentIndex];
      arr[currentIndex] = arr[goToIndex];
      arr[goToIndex] = currentOption;
    },
  },
  created() {
    let i = 10;
    do {
      this.randomOption(this.options);
      i -= 1;
    } while (i > 0);
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/variables.scss';

.options {
  width: 250px;
  font-size: 16px;
  .op-btn {
    padding: 8px 11px;
    margin-bottom: 10px;
    border: 1px solid $primary;
    border-radius: 4px;
    line-height: 22px;
    cursor: pointer;
  }
  .letter {
    color: $primary;
    font-weight: bold;
  }
  .active {
    color: $primary;
    background: #ecf5ff;
    border-color: #b3d8ff;
  }
}
</style>
